export default {
	type: 'object',
	properties: {
		dropEventId: { type: 'string' },
	},
	required: ['dropEventId'],
	additionalProperties: false,
}
